/**
 * The one-time credit packs offered (billing accepts 100 to 50,000 credits)
 * and their price, in dollars per credit. They never expire.
 */
export const CREDIT_PACKS = [500, 1000, 2500, 5000] as const;

export const CREDIT_PACK_PRICE = 0.1;
